import Component from '../../../scripts/utilities/component';

class ImageCaptions extends Component {
    componentDidMount() {
        this.images = [...this.root.querySelectorAll('img')];

        this.images.forEach((image) => {
            this.addCaption(image);
        });
    }

    addCaption(image) {
        let targetEl;
        const parentEl = image.parentNode;
        const longDesc = image.getAttribute('longdesc');

        // Check to see if parent element is a p tag,
        // if so target is the p tag, else its the image
        if (parentEl.tagName.toLowerCase() === 'p') {
            targetEl = parentEl;
        } else {
            targetEl = image;
        }

        // check if there is a longdesc content, then place caption after terget element
        if (longDesc && longDesc.length > 0) {
            targetEl.insertAdjacentHTML('afterend', `<div class="image-caption"><span>${longDesc}</span></div>`);
        }
    }
}

export default ImageCaptions;



// WEBPACK FOOTER //
// ./components/eng-ms-image-captions/scripts/image-captions.js